import {ApiManager} from "@/stores/api/ApiManager";

class WhalyUrlsService {

  constructor(){
    this.url = "whaly-embed-url"
  }

  async getLink(payload = {}) {
    const apiManager = new ApiManager(this.url);
    return await apiManager.get(payload);
  }
}

export default new WhalyUrlsService()